import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { data } from 'jquery';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PEDIDO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setFiltro(filtro) {
    return {
        type: 'PEDIDO_SET_FILTRO',
        payload: filtro
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PEDIDO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('pedidoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {

		const dataInicial = getState().pedido.filtro.data_inicial;
		const dataFinal = getState().pedido.filtro.data_final;

    	axios.get(`${consts.API_URL}/pedido?id_vendedor=${getState().auth.usuario.id_vendedor}&data_inicial=${dataInicial}&data_final=${dataFinal}`)
		.then(resp => {
			dispatch({
		        type: 'PEDIDO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaHistorico() {
	return (dispatch, getState) => {

		const dataInicial = getState().pedido.filtro.data_inicial;
		const dataFinal = getState().pedido.filtro.data_final;

    	axios.get(`${consts.API_URL}/pedido/historico?id_vendedor=${getState().auth.usuario.id_vendedor}&data_inicial=${dataInicial}&data_final=${dataFinal}`)
		.then(resp => {
			dispatch({
		        type: 'PEDIDO_HISTORICO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/pedido`, {
				...registro,
				id_vendedor: getState().auth.usuario.id_vendedor || registro.id_vendedor,
				codigo_vendedor: getState().auth.usuario.codigo_vendedor || registro.codigo_vendedor,
				nome_vendedor: getState().auth.usuario.nome,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				dispatch(getLista());
				dispatch(initForm({
					...resp.data
				}));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/pedido`, {
				...registro,
				id_vendedor: getState().auth.usuario.id_vendedor || registro.id_vendedor,
				codigo_vendedor: getState().auth.usuario.codigo_vendedor || registro.codigo_vendedor,
				nome_vendedor: getState().auth.usuario.nome,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				if (registro.alterarPedido) {
					dispatch(getLista());
					dispatch(initForm({
						...resp.data
					}));
				} else {
					setSuccess('Operação Realizada com sucesso.');
					dispatch(getLista());
					dispatch(setModoTela('lista'));
				}
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedido?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function enviar(registro) {
    return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/pedido/enviar`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			dispatch(getLista());
			dispatch(getListaItens(registro.id));

			axios.get(`${consts.API_URL}/pedido?id=${registro.id}`)
				.then(resp => {
					dispatch(initForm({
						...resp.data[0]
					}));
				}).catch(e => {
					setErroAPI(e);
				});
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function getListaFormaPagamento() {
    const request = axios.get(`${consts.API_URL}/pedido/listarFormaPagamento`);
    return {
        type: 'PEDIDO_FORMA_PAGAMENTO_LISTADO',
        payload: request
    };
}

export function getListaTipoPagamento() {
    const request = axios.get(`${consts.API_URL}/pedido/listarTipoPagamento`);
    return {
        type: 'PEDIDO_TIPO_PAGAMENTO_LISTADO',
        payload: request
    };
}

/*
ITENS
*/

export function getListaItens(idPedido) {
	return (dispatch, getState) => {		
    	axios.get(`${consts.API_URL}/pedidoItem?id_pedido=${idPedido || 0}`)
		.then(resp => {
			dispatch({
		        type: 'PEDIDO_ITEM_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaItensHistorico(idPedido) {
	return (dispatch, getState) => {

		const dataInicial = getState().pedido.filtro.data_inicial;
		const dataFinal = getState().pedido.filtro.data_final;

    	axios.get(`${consts.API_URL}/pedidoItem/historico?id_pedido=${idPedido || 0}`)
		.then(resp => {
			dispatch({
		        type: 'PEDIDO_ITEM_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarItem(registro, evento) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/pedidoItem`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				quantidade_nf: FormatUtils.formatarValorBanco(registro.quantidade_nf, 2),
				vlr_tabela: FormatUtils.formatarValorBanco(registro.vlr_tabela, 2),
				vlr_unitario: FormatUtils.formatarValorBanco(registro.vlr_unitario, 2),
				vlr_desconto: FormatUtils.formatarValorBanco(registro.vlr_desconto, 2),
				perc_desconto: FormatUtils.formatarValorBanco(registro.perc_desconto, 2),
				valor_bruto: FormatUtils.formatarValorBanco(registro.valor_bruto, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				dispatch(getLista());
				dispatch(getListaItens(registro.id_pedido));

				axios.get(`${consts.API_URL}/pedido?id=${registro.id_pedido}`)
				.then(resp => {
					dispatch(initForm({
						...resp.data[0]
					}));
				}).catch(e => {
					setErroAPI(e);
				});
				
				if (evento) {
					evento();
				}
			}).catch(e => {
				setErroAPI(e);
				console.log(e);
				
			});
		} else {
			axios.put(`${consts.API_URL}/pedidoItem`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				quantidade_nf: FormatUtils.formatarValorBanco(registro.quantidade_nf, 2),
				vlr_tabela: FormatUtils.formatarValorBanco(registro.vlr_tabela, 2),
				vlr_unitario: FormatUtils.formatarValorBanco(registro.vlr_unitario, 2),
				vlr_desconto: FormatUtils.formatarValorBanco(registro.vlr_desconto, 2),
				perc_desconto: FormatUtils.formatarValorBanco(registro.perc_desconto, 2),
				valor_bruto: FormatUtils.formatarValorBanco(registro.valor_bruto, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				
				dispatch(getLista());
				dispatch(getListaItens(registro.id_pedido));

				axios.get(`${consts.API_URL}/pedido?id=${registro.id_pedido}`)
				.then(resp => {
					dispatch(initForm({
						...resp.data[0]
					}));
				}).catch(e => {
					setErroAPI(e);
				});

				if (evento) {
					evento();
				}
			}).catch(e => {
				console.log(e);
				
				setErroAPI(e);
			});
		}
    };
}

export function excluirItem(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedidoItem?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			dispatch(getLista());
			dispatch(getListaItens(registro.id_pedido));

			axios.get(`${consts.API_URL}/pedido?id=${registro.id_pedido}`)
				.then(resp => {
					dispatch(initForm({
						...resp.data[0]
					}));
				}).catch(e => {
					setErroAPI(e);
				});

			if (evento) {
				evento();
			}
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function gerarPdf(registro, listaItens) {

	return (dispatch, getState) => {

		dispatch(setAguardando(true));

		let boletos = [];

		// 7- BOLETO
		if (registro.id_tipo_pagamento == 7) {
			const totalPedido = parseFloat(registro.total_pedido);

			let totalNF = 0;
			for (let i = 0; i < listaItens.length; i++) {
				const item = listaItens[i];

				const quantidade = parseFloat(item.quantidade || 0);
				const valorLiquido = parseFloat(item.valor_bruto || 0) - parseFloat(item.vlr_desconto || 0);

				const valorUnitarioLiquido = quantidade > 0 ? valorLiquido / quantidade : 0;

				totalNF += parseFloat(item.quantidade_nf || 0) * valorUnitarioLiquido;
			}

			const formaPagamento = getState().pedido.listaFormaPagamento.find(
				item => item.id == registro.id_forma_pagamento
			);

			const dias = formaPagamento ? formaPagamento.dias : [];

			if (dias.length) {

				// Valor original das parcelas
				const valorParcela = Math.trunc((totalPedido / dias.length) * 100) / 100;
				const diferencaArredondamento = totalPedido - (valorParcela * dias.length);

				// Caso normal
				if (Math.abs(totalNF - totalPedido) < 0.01) {

					for (let i = 0; i < dias.length; i++) {
						boletos.push({
							dia: dias[i],
							data_vencimento: DateFormat.formatarDataSqlParaTela(DateFormat.getDataPosterior(dias[i])),
							valorParcela: FormatUtils.formatarValorTela(valorParcela + (i === dias.length - 1 ? diferencaArredondamento : 0), 2)
						});
					}

				} else {

					// Primeira cobrança = valor da NF
					boletos.push({
						dia: dias[0],
						data_vencimento: DateFormat.formatarDataSqlParaTela(
							DateFormat.getDataPosterior(dias[0])
						),
						valorParcela: FormatUtils.formatarValorTela(totalNF, 2)
					});

					if (totalNF < valorParcela) {

						// Falta completar a primeira parcela
						boletos.push({
							dia: dias[0],
							data_vencimento: DateFormat.formatarDataSqlParaTela(
								DateFormat.getDataPosterior(dias[0] + 1)
							),
							valorParcela: FormatUtils.formatarValorTela(
								valorParcela - totalNF,
								2
							)
						});

						// Demais parcelas permanecem iguais
						for (let i = 1; i < dias.length; i++) {
							boletos.push({
								dia: dias[i],
								data_vencimento: DateFormat.formatarDataSqlParaTela(
									DateFormat.getDataPosterior(dias[i])
								),
								valorParcela: FormatUtils.formatarValorTela(
									valorParcela + (i === dias.length - 1 ? diferencaArredondamento : 0),
									2
								)
							});
						}

					} else {

						// NF maior que a primeira parcela

						const restante = totalPedido - totalNF;
						const qtdRestantes = dias.length - 1;

						if (qtdRestantes > 0) {

							const valorParcelaRestante =
								Math.trunc((restante / qtdRestantes) * 100) / 100;

							const diferenca = restante - (valorParcelaRestante * qtdRestantes);

							for (let i = 1; i < dias.length; i++) {

								let valor = valorParcelaRestante;

								if (i === dias.length - 1)
									valor += diferenca;

								boletos.push({
									dia: dias[i],
									data_vencimento: DateFormat.formatarDataSqlParaTela(
										DateFormat.getDataPosterior(dias[i])
									),
									valorParcela: FormatUtils.formatarValorTela(valor, 2)
								});
							}
						}
					}
				}
			}
		}

		axios.post(`${consts.API_URL}/pedido/gerarPdf`, {
			...registro,
			datahora_emissao: DateFormat.getDataHoraAtual(),
			nome_usuario_emissao: getState().auth.usuario.nome,
			datahora_pedido: DateFormat.formatarDataSqlParaTela(registro.datahora_pedido),
			total_pedido: FormatUtils.formatarValorTela(registro.total_pedido, 2),
			boletos: boletos,
			listaItens: listaItens.map(item => {

				const produto = getState().produto.lista.filter(itemProduto => itemProduto.id_produto == item.id_produto)[0];

				return {
					...item,
					quantidade: FormatUtils.formatarValorTela(item.quantidade, 0),
					quantidade_nf: FormatUtils.formatarValorTela(item.quantidade_nf, 2),
					vlr_tabela: FormatUtils.formatarValorTela(item.vlr_tabela, 2),
					vlr_unitario: FormatUtils.formatarValorTela(item.vlr_unitario, 2),
					vlr_desconto: FormatUtils.formatarValorTela(item.vlr_desconto, 2),
					perc_desconto: FormatUtils.formatarValorTela(item.perc_desconto, 2),
					valor_bruto: FormatUtils.formatarValorTela(item.valor_bruto, 2),
					valor_liquido:
						FormatUtils.formatarValorTela(
							parseFloat(item.valor_bruto || 0)
							- parseFloat(item.vlr_desconto || 0)
						, 2),
					imagem: produto ? produto.imagem : null,
				};
			})
		}).then(resp => {

			dispatch(setAguardando(false));

			if (window.confirm('Seu arquivo está disponível')) {
				const link = document.createElement('a');
				link.href = `data:application/pdf;base64,${resp.data.pdf}`;
				link.download = resp.data.filename;
				link.click();
			}
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}


